import React from "react";
const alertIcon = `${process.env.GATSBY_IMAGE_URL}info-icon.svg`;
const closeIcon = `${process.env.GATSBY_IMAGE_URL}dark-close-icon.svg`;
const AlertError = (props) => {
  return (
    <>
      <div class="alert-container">
        <div class="alert  alert-danger">
          <span class="alert-icon">
            <i>
              <img src={alertIcon} alt="alert" />
            </i>
          </span>
          <p>{props.message}</p>
          <span class="alert-right">
            <a class="alert-close" data-bs-dismiss="alert">
              <img src={closeIcon} alt="close" />
            </a>
          </span>
        </div>
      </div>
    </>
  );
};

export default AlertError;
